module.exports = __webpack_public_path__ + "media/images/yoga_icon-7a2f4c5f6f4df527818584026290cf94.png";